import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../shared/security/auth.service';
import { SaveService } from '../shared/services/save.service';
import { UserService } from '../shared/services/user.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  emptyField: boolean;
  wrongPassword: boolean;
  invalidEmail: boolean;
  userNotFound: boolean;

  form: FormGroup;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private saveService: SaveService,
    private userService: UserService) {

    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

  }

  ngOnInit() {
    this.saveService.setTitle("Se connecter");
  }

  login() {
    console.log("Dans login...............................")
    this.resetError();
    if (this.form.value.email !== '' && this.form.value.email !== null && this.form.value.password !== '' && this.form.value.password !== null) {
      const formValue = this.form.value;
      this.authService.login(formValue.email, formValue.password)
        .subscribe(
        val => {
          this.userService.findUserByUserId(val.uid)
            .subscribe(res => {
              this.saveService.setUser(res)
              if (res.userType === "TEMPO") {
                this.openDialog("Bienvenu chez Urmeo", "Ce code d'usager est un code d'usager temporaire, vous devez créer votre profile pour continuer")
              } else {
                this.resetError();
                this.resetForm();
                if (res.userType === "ADMIN") {
                  this.router.navigate(['responsible-dashboard']);
                } else {
                  this.router.navigate(['student-dashboard']);
                }
              }
            })
        },
        err => this.handleError(err.code)
        );
    } else {
      this.emptyField = true;
    }
  }

  handleError(error) {
    if (error == "auth/user-not-found") {
      this.userNotFound = true
    } else if (error == "auth/invalid-email") {
      this.invalidEmail = true
    } else if (error == "auth/wrong-password") {
      this.wrongPassword = true
    }
  }

  resetError() {
    this.wrongPassword = false;
    this.invalidEmail = false;
    this.userNotFound = false;
    this.emptyField = false;
  }

  resetForm() {
    this.form.reset();
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].setErrors(null)
    });
  }

  openDialog(title, content): void {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '250px',
      width: '300px',
      position: { 'top': '150px' },
      data: {
        content: content,
        title: title,
        twoButton: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['user-update']);
    });
  }

  etudiant() {
    this.form.controls.email.setValue("antoine@hotmail.com");
    this.form.controls.password.setValue("Proij$18");
  }

  responsable() {
    this.form.controls.email.setValue("isabelle@hotmail.com");
    this.form.controls.password.setValue("Proij$18");
  }

  tempo() {
    this.form.controls.email.setValue("admin125501@urmeo.com");
    this.form.controls.password.setValue("123456");
  }

}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/login/login.component.ts